import { useEffect, useState } from 'react';
import { call, type GetToken, type PlanListResponse, type PlanSummary } from './api';

/**
 * The teacher's plans from `/api/plans`, fetched while `enabled`: undefined until the first
 * answer, null when it failed or was not a list. A later failure keeps the plans already loaded.
 */
export function usePlanList(getToken: GetToken, enabled = true) {
  const state = useState<PlanSummary[] | null | undefined>(undefined);
  const setPlans = state[1];
  useEffect(() => {
    if (!enabled) return;
    let live = true; const controller = new AbortController();
    void call<PlanListResponse>(getToken, '/api/plans', { signal: controller.signal })
      .then(list => (Array.isArray(list.plans) ? list.plans : null), () => null)
      .then(next => { if (live) setPlans(p => next ?? p ?? null); });
    return () => { live = false; controller.abort(); };
  }, [getToken, enabled, setPlans]);
  return state;
}
